// extracted by mini-css-extract-plugin
module.exports = {"containerform":"todoList_containerform__3GFTL","todoContainer":"todoList_todoContainer__2bLKM","btn":"todoList_btn__1Rl4O"};